let loadPromise: Promise<void> | null = null;

export function loadGoogleMapsScript(apiKey: string): Promise<void> {
	if (loadPromise) return loadPromise;

	if (typeof google !== 'undefined' && google.maps?.places) {
		return Promise.resolve();
	}

	loadPromise = new Promise<void>((resolve, reject) => {
		const existing = document.querySelector(
			'script[src*="maps.googleapis.com"]'
		);
		if (existing) {
			if (typeof google !== 'undefined' && google.maps?.places) {
				resolve();
				return;
			}
			existing.addEventListener('load', () => resolve());
			existing.addEventListener('error', () =>
				reject(new Error('Failed to load Google Maps'))
			);
			return;
		}

		const callbackName = '__googleMapsLoaded__';
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(window as any)[callbackName] = () => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			delete (window as any)[callbackName];
			resolve();
		};

		const script = document.createElement('script');
		script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=en&loading=async&callback=${callbackName}`;
		script.async = true;
		script.onerror = () => {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			delete (window as any)[callbackName];
			reject(new Error('Failed to load Google Maps'));
		};
		document.head.appendChild(script);
	});

	return loadPromise;
}
